import { memo, useMemo, CSSProperties } from "react";
import { COLUMN_WIDTH, ROW_HEIGHT, BORDER } from "../../../../CONSTANTS";
import { ColumnRowProps } from "../../ColumnRowProps";
import { TopRowColumnRow } from "./TopRowColumnRow";


export const TopRowColumnContainer = memo(function TopRowColumnContainer({ columnIndex, columnRow, rowId, start }: ColumnRowProps & { start: number }) {
    const style = useMemo(() => {
        return {
            width: `${COLUMN_WIDTH}px`,
            position: 'absolute',
            transform: `translateX(${start}px)`,
            top: 0,
            left: 0,
            height: `${ROW_HEIGHT}px`,
            boxSizing: 'border-box',
            borderBottom: BORDER,
            borderRight: BORDER,
            display: 'flex',
            justifyContent: 'center',
        } as CSSProperties;
    }, [start]);
    return (
        <div style={style}>
            <TopRowColumnRow columnRow={columnRow} columnIndex={columnIndex} rowId={rowId} />
        </div>
    );
});